import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToTravelPlan,
    navigateToAboutYou,
    navigateToTravelDetails,
    navigateToPlans,
    navigateToPayment,
} from '../../../actions/roaTravelInsurance/routing';
import { getActivePageIndex } from '../../../selectors/roaTravelInsurance/routing';
import { PAGE_INDICES } from '../../../actions/roaTravelInsurance/types';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS)
        return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.TRAVEL_PLAN:
            store.dispatch(navigateToAboutYou());
            break;
        case PAGE_INDICES.ABOUT_YOU:
            store.dispatch(navigateToTravelDetails());
            break;
        case PAGE_INDICES.TRAVEL_DETAILS:
            store.dispatch(navigateToPlans());
            break;
        case PAGE_INDICES.PLANS:
            store.dispatch(navigateToPayment());
            break;
        default:
            store.dispatch(navigateToTravelPlan());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.ABOUT_YOU:
            store.dispatch(navigateToTravelPlan());
            break;

        case PAGE_INDICES.TRAVEL_DETAILS:
            store.dispatch(navigateToAboutYou());
            break;

        case PAGE_INDICES.PLANS:
            store.dispatch(navigateToTravelDetails());
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(navigateToPlans());
            break;
        default:
            store.dispatch(navigateToTravelPlan());
            break;
    }
};
